import React from 'react';

export const PageBranding = ({ logo, template, content, scale = 1.33333 }) => {
  const path = logo?.resolutions?.full?.path;
  const url = `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${path}`;

  const {
    heading_align = 'center',
    logo_width_pt,
    // margin_bottom_pt,
    // margin_left_pt,
    // margin_right_pt,
    // margin_top_pt,
  } = template || {};

  const wrapperStyle = {
    textAlign: heading_align,
  };

  const style = {
    width: `${logo_width_pt * scale}px`,
  };

  return (
    <div
      className="branding"
      style={wrapperStyle}
    >
      {!!path && (
        <img
          src={url}
          style={style}
          alt="page branding"
        />
      )}
      {!!content && (
        <div className="branding__content">
          {content}
        </div>
      )}
    </div>
  );
};

export const EmailBranding = ({ logo, template }) => {
  const path = logo?.resolutions?.full?.path;
  const url = `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${path}`;

  const {
    heading_align,
    logo_width_pt,
    // margin_bottom_pt,
    // margin_left_pt,
    // margin_right_pt,
    // margin_top_pt,
  } = template || {};

  const wrapperStyle = {
    textAlign: heading_align,
  };

  const style = {
    width: `${logo_width_pt}pt`,
  };

  return (
    <div style={wrapperStyle}>
      <img
        src={url}
        style={style}
        alt="email branding"
      />
    </div>
  );
};
